import { render } from "./App.vue?vue&type=template&id=05dc7cd7"
const script = {}

import "./App.vue?vue&type=style&index=0&id=05dc7cd7&lang=css"

import exportComponent from "/home/pk/projects/Tha_Chamber/thachamber/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__